module.exports = __webpack_public_path__ + "static/media/ken_up_3.a145eb02.jpg";